import { Outlet } from 'react-router-dom';

export default function GuestLayout() {
    return (
        <div className="min-h-screen bg-gray-50">
            <Outlet />
        </div>
    );
}
